import { useEffect, useState } from 'react';

/**
 * A value that settles after typing stops.
 *
 * Every search box in the app now hits the server, and without this each keystroke is a
 * query whose answers come back out of order — "Hend" landing after "Henderson" and
 * replacing the right results with stale ones. 250ms is long enough that a typed word is
 * one request and short enough that nobody notices waiting.
 */
export function useDebounced<T>(value: T, ms = 250): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setSettled(value), ms);
    return () => clearTimeout(id);
  }, [value, ms]);
  return settled;
}
